import { t } from 'i18next';

import { formattedDateTime } from '../../../../../../utils/dateUtils';
import { DataTableColumns } from '../../../../data-table/data-table';
import { IntegrationAsbuiltPoint } from '../../../../integrations/state/integrations-state';

export const asbuiltContentColumns = (): DataTableColumns<IntegrationAsbuiltPoint> => {
  return {
    name: {
      title: t('asBuiltColumns.name', { ns: 'skyviewAsbuilt' }),
    },
    measureType: { title: t('asBuiltColumns.type', { ns: 'skyviewAsbuilt' }) },
    x: {
      title: t('asBuiltColumns.x', { ns: 'skyviewAsbuilt' }),
      formatter: (value) => value?.toFixed(3).toString() ?? '',
    },
    y: {
      title: t('asBuiltColumns.y', { ns: 'skyviewAsbuilt' }),
      formatter: (value) => value?.toFixed(3).toString() ?? '',
    },
    z: {
      title: t('asBuiltColumns.z', { ns: 'skyviewAsbuilt' }),
      formatter: (value) => value?.toFixed(3).toString() ?? '',
    },
    description: { title: t('asBuiltColumns.description', { ns: 'skyviewAsbuilt' }) },
    category: { title: t('asBuiltColumns.category', { ns: 'skyviewAsbuilt' }) },
    fileReference: { title: t('asBuiltColumns.fileReference', { ns: 'skyviewAsbuilt' }) },
    localId: { title: t('asBuiltColumns.localId', { ns: 'skyviewAsbuilt' }) },
    machineId: { title: t('asBuiltColumns.machineId', { ns: 'skyviewAsbuilt' }) },
    machineName: { title: t('asBuiltColumns.machineName', { ns: 'skyviewAsbuilt' }) },
    timestampMs: {
      title: t('asBuiltColumns.timestamp', { ns: 'skyviewAsbuilt' }),
      formatter: (value: number) => (value ? formattedDateTime(new Date(value)) : ''),
    },
    integration: { title: t('asBuiltColumns.integrationName', { ns: 'skyviewAsbuilt' }) },
  };
};
